import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/** PRC Table of General Standard Chinese Characters data for a grapheme. */
export const graphemePrcDataTable = staticTable(
  "grapheme_prc_data",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    /** Earliest HSK 2.0 level at which this grapheme is required. */
    minHsk2010Level: integer("min_hsk_2010_level"),

    /** Earliest HSK 3.0 level at which this grapheme is required. */
    minHsk2021Level: integer("min_hsk_2021_level"),

    /** Earliest HSK 3.1 level at which this grapheme is required. */
    minHsk2026Level: integer("min_hsk_2026_level"),

    /**
     * PRC Table of General Standard Chinese Characters tier (1, 2, or 3). `null` means the
     * character is only referenced as a decomposition component (not on the list itself).
     */
    tier: integer("tier"),

    // NOTE: keep `rank`/`tier*CompoundsCount` AFTER `tier`. The haniverse-worker deploy loads
    // static.db into D1 with a positional `sqlite3 .dump`, so the column order created from
    // this schema must match D1's. These columns were added to D1 via `ALTER TABLE ADD`
    // (appended), so any column introduced after the initial migration must be declared at
    // the end here too — otherwise the dump misaligns and NOT NULL constraints fail.
    rank: integer("rank").notNull(),
    tier1CompoundsCount: integer("tier_1_compounds_count")
      .notNull()
      .$default(() => 0),
    tier2CompoundsCount: integer("tier_2_compounds_count")
      .notNull()
      .$default(() => 0),
    tier3CompoundsCount: integer("tier_3_compounds_count")
      .notNull()
      .$default(() => 0),
  },
  (table) => [index("grapheme_prc_data_grapheme_id_idx").on(table.graphemeId)],
);

export type GraphemePrcData = typeof graphemePrcDataTable.$inferSelect;
